import React from "react";
import {QuicklinkButtonImage, ResidentIcon} from "../../../../global/style";

export default function ButtonImageQuicklink({text, image}) {

  return (
    <QuicklinkButtonImage>
        <ResidentIcon src={image}/>
      &nbsp;{text}
    </QuicklinkButtonImage>
  )
}